import { JobListMetaDataResponse } from '@doda/api-client/aspida/@types';
import { JOB_COUNT_PER_PAGE } from 'constants/jobList';

interface Props {
  /** 求人リストのレスポンス */
  jobListMeta?: JobListMetaDataResponse;
  /** ページ毎表示求人数クエリ */
  so?: string;
}

/**
 * ページ数を算出する
 *
 * @param {Props} param - 関数の引数オブジェクト
 * @param {JobListMetaDataResponse} param.jobListMeta - 求人リストのレスポンス
 * @param {string} [param.so] - ページ毎表示求人数クエリ
 * @returns {number} ページ数
 */
export const calcMaxPage = ({ jobListMeta, so }: Props) => {
  if (!jobListMeta || !jobListMeta.totalCount) return 0;
  const displayNumPerPage = so ? Number(so) : JOB_COUNT_PER_PAGE;
  return Math.ceil(jobListMeta.totalCount / displayNumPerPage);
};
